import { ShopsView } from '../../../_generated';
import { ShopsAction, ShopsActionType } from '../../actionstypes/shops/shops.actiontype';

const initialState: ShopsView[] = [];

export default (state = initialState, action: ShopsActionType): ShopsView[] => {
  switch (action.type) {
    case ShopsAction.Get:
      return action.payload;

    case ShopsAction.Reset:
      return [];

    default:
      return state;
  }
};
